/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { PackageVoModel } from '@well/delivery-libs/packages/domain';
import { TaskCheckpointDTO } from './task-checkpoint-dto.model';

export class TaskDtoModel extends JSONable {

  uuid: string | undefined = undefined;
  segmentRouteUuid: string | undefined = undefined;
  routingSolutionUuid: string | undefined = undefined;
  packagesGroupUuid: string | undefined = undefined;
  packageVOS: PackageVoModel[] | undefined = undefined;
  pickupCheckpointDTO: TaskCheckpointDTO | undefined = undefined;
  deliveryCheckpointDTO: TaskCheckpointDTO[] | undefined = undefined;
  returnCheckpointDTO: TaskCheckpointDTO | undefined = undefined;
}
